import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { getUserDashboard } from './api';
import { loginLogout, useProjectByStorage } from './projectData';

const RouteDataContext = createContext();

export const RouteDataProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const [dashboard, setDashboard] = useState(null);
    const [company] = useState(localStorage.getItem('company') || 'null')
    const location = useLocation();

    const params = useParams();

    const navigate = useNavigate();

    const project = useProjectByStorage();
    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('cuslogin') || 'null');
        if (userData && userData.api_token) {
            setUserData(userData)
            console.log('useEffect')
        }

    }, []);

    useEffect(() => {
        if (userData && project) {
            getUserData(userData?.user?.iirpl_sap_code, project?.pkey)
        }
    }, [userData, project])

    const getUserData = (iirpl_sap_code, project_key) => {
        getUserDashboard({ id: iirpl_sap_code, project_key: project_key }).then((d) => setDashboard(d?.data))
            .catch((error) => {
                loginLogout(error.response)
            })
    }
    const logout = () => {
        setUserData(null);
        localStorage.removeItem('cuslogin');
    }

    const [routeData, setRouteData] = useState({
        location,
        params,
        searchParams: new URLSearchParams(location.search),
    });


    useEffect(() => {
        setRouteData({
            location,
            params,
            searchParams: new URLSearchParams(location.search),
        });

    }, [location, params]);


    return (
        <RouteDataContext.Provider value={{ routeData, navigate, userData, logout, company, dashboard, getUserData }}>
            {children}
        </RouteDataContext.Provider>
    );
};


export const useRouteData = () => {
    return useContext(RouteDataContext);
};
